import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  createAcceptance,
  createBaggage,
  createMockData,
  createMockDataWithResponse,
  MockAcceptance,
} from '@dapi/sdk/spec';
import {
  acceptedMultiLegMultiPaxJourney,
  addedBaggageTemplate,
  defaultCheckInBaggagePoliciesFor2Adt,
  firstFreeSeatOnMultiLegJourney,
  multiLegMultiPaxBoardingPassResultForSameFreeSeats,
  multiLegMultiPaxJourneys,
  multiLegSeatmap,
  noItemToPayError,
} from '../../mock/data';
import {
  checkedInJourneyElementMultiLeg2ADTWithFreeSeats,
} from '../../mock/dictionaries';

const acceptance: MockAcceptance = createAcceptance({
  template: {
    checkedInJourneyElements: checkedInJourneyElementMultiLeg2ADTWithFreeSeats,
    isAccepted: true
  }
});

/**
 * OW Multileg 1Journey
 * 2ADT
 * free seats
 */
export const owMultileg2AdtSeatItineraryDetailsBoardingPassRetrieve: MockMap = {
  generateBoardingPasses: [
    createMockDataWithResponse(multiLegMultiPaxBoardingPassResultForSameFreeSeats, 201),
    createMockDataWithResponse(multiLegMultiPaxBoardingPassResultForSameFreeSeats, 201),
    createMockDataWithResponse(multiLegMultiPaxBoardingPassResultForSameFreeSeats, 201),
    createMockDataWithResponse(multiLegMultiPaxBoardingPassResultForSameFreeSeats, 201)
  ],
  addJourneyBags: [createMockData([
    createBaggage({
      template: addedBaggageTemplate,
      id: 0
    }),
    createBaggage({
      template: addedBaggageTemplate,
      id: 1
    })
  ])],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePoliciesFor2Adt]).items)],
  getJourneyUnpaidItems: [
    createMockData(noItemToPayError)
  ],
  assignSeatToJourneyElement: [
    createMockDataWithResponse(firstFreeSeatOnMultiLegJourney[0], 201)
  ],
  updateJourneySeats: [
    createMockData(firstFreeSeatOnMultiLegJourney)
  ],
  updateJourneyElement: [
    createMockData(firstFreeSeatOnMultiLegJourney)
  ],
  requestAcceptanceOfJourney: [
    createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(acceptance, 201)
  ],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [
    createMockDataWithResponse(multiLegMultiPaxJourneys, 201),
    createMockDataWithResponse([acceptedMultiLegMultiPaxJourney], 201)
  ],
  retrieveJourney: [
    createMockData({
      ...acceptedMultiLegMultiPaxJourney,
      journeyElements: checkedInJourneyElementMultiLeg2ADTWithFreeSeats
    })
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(multiLegSeatmap)]
};
